
// * ========================================================================
// * dead chart
// * ========================================================================

import CovidChart from './covid-chart.js';
import moment from 'moment';

const dead = (function(){
    const typeSelectorClass = 'input[name=dead-chart-data]';

    let thisChart = null;
    let dataType = null;
    let typeSelectors = null;
    let chartData = null;
    let chartFirstDate = null;
    const lag = -(8*7);
    let delay = moment().add(lag, 'day').format('YYYY-MM-DD');

    function createChartData(data, options) {
        let datasets = [{
            label: 'Yhteensä',
            id: 'all',
            type: 'LineWithLine',
            borderColor: '#0293d6',
            borderWidth: 3,
            count: 0,
            fill: false,
            data: [],
            pointRadius: 0,
            yAxisID: 'y'
        }, {
            label: 'Kuolemia',
            id: 'deaths',
            type: 'bar',
            borderColor: '#000000',
            borderWidth: 3,
            count: 0,
            fill: false,
            data: [],
            pointRadius: 0,
            yAxisID: 'y2',
            hideChange: true
        }];

        // Create data
        let firstDayValue = null;
        for (let item of data.dead.days) {
            const date = moment(item.date);

            // Push only after first visible date
            if (date >= chartFirstDate) {
                firstDayValue = firstDayValue === null ? item.countTotal : firstDayValue;

                // Show all or new deaths?
                let deadTotalCount = dataType === 'date' ? item.countTotal - firstDayValue : item.countTotal;
                deadTotalCount = deadTotalCount < 0 ? 0 : deadTotalCount;

                datasets[0].data.push({
                    x: date,
                    y: deadTotalCount
                });

                datasets[1].data.push({
                    x: date,
                    y: item.count
                });
            }
        }

        return datasets;
    }

    function getDataType() {
        dataType = document.querySelector(typeSelectorClass+':checked').value;
        return dataType;
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     * @param {Object} options - chart options
     */
    function init(data, options) {
        if (!document.getElementById('dead-chart')){
            return;
        }
        chartData = data;
        chartFirstDate = window.config.firstDayValues['dead'];

        typeSelectors = document.querySelectorAll(typeSelectorClass);

        // Get the data type we want to show
        getDataType();

        const datasets = createChartData(chartData, window.config);

        thisChart = new CovidChart('dead-chart', {
            datasets,
            chartOptions: {
                type: 'line',
                options: {
                    plugins: {
                        tooltip: {
                            intersect: false,
                            position: 'nearest',
                            bodySpacing: 5,
                        },
                        /*annotation: {
                            annotations: [
                                {
                                    type: 'line',
                                    mode: 'vertical',
                                    scaleID: 'x',
                                    value: delay,
                                    borderColor: '#e80a9a',
                                    borderWidth: 2,
                                    label: {
                                        content: 'viive',
                                        enabled: true,
                                        position: 'top',
                                        rotation: 0,
                                        xAdjust: 40,
                                        yAdjust: 4,
                                        xPadding: 4,
                                        yPadding: 5,
                                        backgroundColor: '#e80a9a'
                                    }
                                }
                            ]
                        },*/
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'D.M.YY',
                                }
                            }
                        },
                        y: {
                            type: 'linear',
                            position: 'left',
                        },
                        y2: {
                            type: 'linear',
                            position: 'right',
                        }
                    },
                }
            },
            config: window.config,
            tooltips: {
                elementId: 'dead-chart-tooltip'
            }
        });

        // Create listener for type change
        typeSelectors.forEach((typeSelector) => {
            typeSelector.addEventListener('change', () => {
                let newType = document.querySelector(typeSelectorClass+':checked').value;
                if (dataType !== newType) {
                    reload(null, true);
                }
            });
        });
    }

    function reload(data = null, changeType = false) {
        if (!document.getElementById('dead-chart')){
            return;
        }

        if (data) {
            chartData = data;
        }

        // Get the data type we want to show
        getDataType();

        if (!changeType) {
            // New first date value
            chartFirstDate = window.config.firstDayValues['dead'];
        }

        // Update data
        const datasets = createChartData(chartData, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default dead;
